// Arquivo do CRUD de tgs
import { useEffect, useState } from 'react'
import { Container } from "./styles"
import Button from "../../../components/Button"
import Input from "../../../components/Input"
import { api } from "../../../services/api"
import { /* useLocation,*/ useHistory, useParams } from "react-router-dom"
import Form from '../../../components/Forms'
import {alert} from '../../../components/Alert'
import { Page } from '../../AdminDashboard/styles'

const EditTag = (props) => {
  const history = useHistory()
  // const location = useLocation()

  let{id} = useParams()

  const [name, setName] = useState('');
  const [icon, setIcon] = useState('');

  const LoadTag = async (id) => {
    const response = await api.get(`tags/show/${id}`)
    setName(response.data.name)
    setIcon(response.data.icon_name)
  }

  const addTags = (e) => {
    e.preventDefault();
    api.patch(`tags/update/${id}`, {
      tag: {
        name: name,
        icon_name: icon
      }
    }).then((response) => {
      console.log(response)
      response.status===200 ? alert("atualizado com sucesso", 'success') : alert("erro, tente novamente", 'error')
      history.push("/tags")
    }).catch((error => {
      alert("erro, tente novamente", 'error')
    }))
  }

  useEffect(() => {
    LoadTag(id)
  }, [id])

    return (
      <Page>
        <Container>
          <h1>Editar Tag</h1>
          <Form
            onSubmit={addTags}
            title='Tag'
            text='Edite os campos para atualizar uma tag.'
            button={
              <>
                  <Button format='submit' type='submit'>Editar tag</Button>
                  <Button format='return' type='button' onClick={() => history.goBack()}>Voltar</Button>
              </>
            }
          >
            <Input label='Nome' value={name} onChange={(e)=>setName(e.target.value)}></Input>
            <span>
                O nome do ícone deve ser pego do site 
                <a href='https://react-icons.github.io/react-icons/icons?name=fi' target='_blank' rel="noopener noreferrer"> react-icons</a>,
                qualquer ícone desse site <strong>COM A EXEÇÃO</strong> dos icones de:
                Ionicons 5 e VS Code Icons
            </span>
            <Input label='Nome do ícone' value={icon} onChange={(e)=>setIcon(e.target.value)}></Input>
          </Form>
        </Container>
      </Page>
    )
}

export default EditTag
